import React from "react";
import * as Lucide from "lucide-react";

// Renders a lucide icon by name (from config strings). Falls back to a dot.
export default function Icon({ name, className = "h-5 w-5", ...rest }) {
  const Cmp = Lucide[name] || Lucide.Circle;
  return <Cmp className={className} aria-hidden="true" {...rest} />;
}
